import React from "react"
import ZdqConnectorSetup from "../../components/ZdqConnectorSetup"
import { DELTALAKE } from "../../Constants"

function ZdqDeltaLakeConnector() {
    return <ZdqConnectorSetup vendor={DELTALAKE}></ZdqConnectorSetup>
}

export default ZdqDeltaLakeConnector